import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueLazyload from 'vue-lazyload';
import Toast from '@/components/Toast';
import Dialog from '@/components/Dialog';
import Loading from '@/components/Loading';
import ServiceError from '@/components/ServiceError';

Vue.config.productionTip = false;
/**
 * 保证在80%+页面使用到组件，在这里使用use
 * 尽可能使chunk-vendors.js文件size小
 **/
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(ServiceError);
Vue.use(VueLazyload, {
  preLoad: 1.4, //预加载的宽高比
  // error: 'images/error.png', //图片加载失败时使用的图片源
  // loading: 'images/loading.gif', //图片加载的路径
  attempt: 1, //尝试加载次数
  filter: {
    webp(listener, options) {
      if (!options.supportWebp) return;
      if (typeof listener.src === 'string' && /img12.360buyimg.com/.test(listener.src) && listener.src.indexOf('?') === -1) {
        listener.src = listener.src + '.dpg';
      }
    }
  }
});

// Vue.directive('focus', {
//   inserted: function(e) {
//     e.focus();
//   }
// });

router.beforeEach((to, from, next) => {
  try {
    console.log(router.options.routes);
    if (to.matched && to.matched.length === 0) {
      const routes = router.options.routes;
      let _path = '/';
      for (let index = 0; index < routes.length; index++) {
        const route = routes[index];
        if (to.path.indexOf(route.path) > -1) {
          _path = route.path;
        }
      }

      if (_path) {
        return next({ path: _path });
      }
    }
    if (to.meta && to.meta.title) {
      document.title = to.meta.title;
    }

    if (window.__qd__ && window.__qd__.page) {
      // 上报事件
      window.__qd__.page(to.fullPath, from.fullPath);
    }
  } catch (error) {
    console.log(error);
  }
  next();
});

router.afterEach((to, from) => {
  try {
    // 发送埋点
    console.log('成功浏览到: ', to, from);
    const stt = setTimeout(() => {
      clearTimeout(stt);
      window.sendPageClstag && window.sendPageClstag(to.name);
    }, 300);
  } catch (error) {
    console.log(error);
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
